// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.table-container {
  /* max-height: calc(100vh - 365px); */
  overflow: auto;
}

table {
  overflow: auto;
  border-collapse: collapse;
  width: 100%;
}

.table-spec {
  width: 100%;
  max-width: 100%;
  empty-cells: show;
  border: 0;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  font-weight: normal;
}

td {
  padding: 6px 10px;
}

th {
  border-top: none;
  position: sticky;
  top: 0;
  padding: 10px;
  background: #212529;
  color: #ffffff;
  font-size: 14px;
  z-index: 1;
}

tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

td .txtarea {
  width: 100% !important;
}

td textarea:hover {
  border: 1px solid gray !important;
}

.first td:nth-child(1) {
  color: teal;
}

.addEquipInput{
  width: 235px;
  border:  1px solid rgb(211, 211, 211);
  border-radius: 5px;
}


.inactiveTab {
  background-color:#dddddd;
  color: gray;
}

.activeTab {
  background-color:#ffffff;
  box-shadow: 0px 0px 10px 0px rgba(97, 96, 97, 0.5);
}

.radio-container {
  transform: scale(0.85);
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: teal!important;
  border-color: teal;
}
.custom-checkbox .custom-control-input:checked:focus ~ .custom-control-label::before {    
  box-shadow: none;   
  border-color: teal;
}
.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;  
  border-color: teal;  
}

.alignIt
{
  margin-right: 5px;
  /* float: right; */
  /* padding-bottom: 1px; */
}

.disabled {
  cursor: not-allowed;
}


.app-toolbar{
  border:1px solid grey;
  position: sticky;
  position: -webkit-sticky; 
  top: 0;
  z-index: 1000;
}

.labelStyle{
  font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; 
  font-size: 14px;
}

span[aria-label-action]:hover:after {
  content: attr(aria-label-action);
  padding: 4px 8px;
  position: absolute;
  right: 30px;
  top: -10px;
  white-space: nowrap;
  z-index: 999999;
  background:teal;
  color: white;
  border-radius: 5px;
  font-size: 16px;
}

.tableColumnFilter {
  background-color: white;
  border-radius: 4px;
  width: 100%;
  height: 31px;
  color:black;
  padding-left: 15px;
  border: 2px hidden black;
}

.show-hide {
  display: flex;
  justify-content: flex-end;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/master-data-management/admin-unit-make/admin-unit-make.component.css"],"names":[],"mappings":";AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;;AAGA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,mFAAmF;EACnF,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA,osKAAosK","sourcesContent":["\r\n.table-container {\r\n  /* max-height: calc(100vh - 365px); */\r\n  overflow: auto;\r\n}\r\n\r\ntable {\r\n  overflow: auto;\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n}\r\n\r\n.table-spec {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  empty-cells: show;\r\n  border: 0;\r\n}\r\n\r\ntd, th {\r\n  border: 1px solid #dddddd;\r\n  text-align: left;\r\n  font-weight: normal;\r\n}\r\n\r\ntd {\r\n  padding: 6px 10px;\r\n}\r\n\r\nth {\r\n  border-top: none;\r\n  position: sticky;\r\n  top: 0;\r\n  padding: 10px;\r\n  background: #212529;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  z-index: 1;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n  width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n  border: 1px solid gray !important;\r\n}\r\n\r\n.first td:nth-child(1) {\r\n  color: teal;\r\n}\r\n\r\n.addEquipInput{\r\n  width: 235px;\r\n  border:  1px solid rgb(211, 211, 211);\r\n  border-radius: 5px;\r\n}\r\n\r\n\r\n.inactiveTab {\r\n  background-color:#dddddd;\r\n  color: gray;\r\n}\r\n\r\n.activeTab {\r\n  background-color:#ffffff;\r\n  box-shadow: 0px 0px 10px 0px rgba(97, 96, 97, 0.5);\r\n}\r\n\r\n.radio-container {\r\n  transform: scale(0.85);\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\r\n  background-color: teal!important;\r\n  border-color: teal;\r\n}\r\n.custom-checkbox .custom-control-input:checked:focus ~ .custom-control-label::before {    \r\n  box-shadow: none;   \r\n  border-color: teal;\r\n}\r\n.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before {\r\n  box-shadow: none;  \r\n  border-color: teal;  \r\n}\r\n\r\n.alignIt\r\n{\r\n  margin-right: 5px;\r\n  /* float: right; */\r\n  /* padding-bottom: 1px; */\r\n}\r\n\r\n.disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n\r\n.app-toolbar{\r\n  border:1px solid grey;\r\n  position: sticky;\r\n  position: -webkit-sticky; \r\n  top: 0;\r\n  z-index: 1000;\r\n}\r\n\r\n.labelStyle{\r\n  font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; \r\n  font-size: 14px;\r\n}\r\n\r\nspan[aria-label-action]:hover:after {\r\n  content: attr(aria-label-action);\r\n  padding: 4px 8px;\r\n  position: absolute;\r\n  right: 30px;\r\n  top: -10px;\r\n  white-space: nowrap;\r\n  z-index: 999999;\r\n  background:teal;\r\n  color: white;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n}\r\n\r\n.tableColumnFilter {\r\n  background-color: white;\r\n  border-radius: 4px;\r\n  width: 100%;\r\n  height: 31px;\r\n  color:black;\r\n  padding-left: 15px;\r\n  border: 2px hidden black;\r\n}\r\n\r\n.show-hide {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
